module.exports = __webpack_public_path__ + "img/icon-our-platform.404393e4.png";